import _ from 'lodash';

import MenuBarItem from '../menuBar/item';

import withCustomDropPanel from '../hocs/withCustomDropPanel';
import withDropDownOnClick from '../hocs/withDropDownAction/withDropDownOnClick';

export default _.flow(
  withDropDownOnClick,
  withCustomDropPanel(({ handlerKey }) => handlerKey),
)(MenuBarItem);
